module.exports = "<h1>Manufacturers in progress.</h1>\r\n"